module.exports = __webpack_public_path__ + "static/img/weixin_erweim4.fd94e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin_erweim4.png
// module id = gYhE
// module chunks = 16